



















import { Component, Prop, Watch } from 'vue-property-decorator'
import {Debounce} from "vue-debounce-decorator";
import { BaseBorderless } from "@share/common/form/form-controls/base/borderless/base-borderless";

@Component({})
export default class TimeSelector extends BaseBorderless {
    @Prop() from: string;
    @Prop() to: string;

    str = '';
    minTime = 6;
    maxTime = 24;
    times: string[] = [];
    currentFrom = '';
    currentTo = '';
    showSelector = false;
    wasSelected = false;

    get timeRange() {
        return this.$store.getters['meetingsTimeRange'];
    }

    get timesWithoutLast() {
        return this.times.slice(0,-1);
    }

    mounted() {
        this.generateTimes();
        this.currentFrom = this.from;
        this.currentTo = this.to;
        this.generateStr();
    }

    @Watch('to')
    onToChange(newValue: string) {
        if(this.currentTo != newValue) {
            this.currentTo = newValue;
            if (newValue) {
                this.generateStr();
            }
        }
    }
    @Watch('from')
    onFromChange(newValue: string) {
        if (this.currentFrom != newValue) {
            this.currentFrom = newValue;
            if (newValue) {
                this.generateStr();
            }
        }
    }

    @Watch('currentFrom')
    onCurrentFromChange(newValue: string | null) {
        if (newValue && !this.wasSelected) {
            this.$nextTick(() => {
                this.scrollToSelected('from');
            })
        }
        this.wasSelected = false;
    }

    @Watch('currentTo')
    onCurrentToChange(newValue: string | null) {
        if (newValue && !this.wasSelected) {
            this.$nextTick(() => {
                this.scrollToSelected('to');
            })
        }
        this.wasSelected = false;
    }

    async scrollToSelected(list: string) {
        const element: HTMLElement = list == 'from' ? this.$refs.fromList as HTMLElement : this.$refs.toList as HTMLElement;
        if (element) {
            const selected = element.querySelector('.selected') as HTMLElement;
            if (selected) {
                element.scrollTop = selected.offsetTop;
            }
        }
    }

    keyDown(e: any) {
        const charCode = (e.which) ? e.which : e.keyCode;
        if ((charCode >= 48 && charCode <= 57) ||
            [8, 186, 46, 8, 9, 27, 13, 110, 190, 37, 39].indexOf(charCode) > -1 ||
            ((charCode == 65 || charCode == 86 || charCode == 67) && (e.ctrlKey === true || e.metaKey === true))
        ) {
            if (charCode != 8 && this.str.length == 5) {
                this.str += ' - ';
            }
            if (charCode == 8 && this.str.endsWith(' - ') &&  this.str.length > 5) {
                this.str = this.str.slice(0, 6);
                this.keyUp();
            }
        }
        else {
            e.preventDefault();
        }
    }


    @Debounce(300)
    keyUp() {
        const exploded = this.str.split('-').map(item => item.trim());
        exploded[0] && (this.currentFrom = exploded[0]);
        exploded[1] && (this.currentTo = exploded[1]);
        this.emitChange();
    }

    @Debounce(50)
    generateStr() {
        this.str = [this.currentFrom, this.currentTo].filter(item => item).join(' - ');
    }

    emitChange() {
        const from = this.times.indexOf(this.currentFrom) > -1 ? this.currentFrom : null,
            to = this.times.indexOf(this.currentTo) > -1 ? this.currentTo : null;
        this.$emit('changed', {from, to});
    }

    generateTimes() {
        const generateRange = (min: number, max: number, isLast = false) => {
            const getPair = (hour: number, minutes: number) => {
                return {
                    hour: hour < 10 ? `0${hour}` : hour,
                    minutes: minutes < 10 ? `0${minutes}` : minutes
                }

            }
            for (let i = min; i < max; i++) {
                for (let j = 0; j <= 45; j += 15) {
                    const {
                        hour, minutes
                    } = getPair(i,j);
                    this.times.push(`${hour}:${minutes}`);
                }
            }
            if (isLast) {
                const {
                    hour, minutes
                } = getPair(max, 0);
                this.times.push(`${hour}:${minutes}`);
            }
        }

        const ranges = [],
              end = this.timeRange?.end || 24;
        let begin = this.timeRange?.begin || 0;

        if (begin < 0) {
            ranges.push({
                    begin: 24 - Math.abs(begin),
                    end: 24
                }
            )
            begin = 0;
        }

        ranges.push({
            begin: begin,
            end: end > 24 ? 24 : end
        })

        if (end > 24) {
            ranges.push({
                begin: 0,
                end: end - 24
            });
        }

        ranges.forEach((item, index) => {
            generateRange(item.begin, item.end, index == ranges.length - 1);
        })
    }

    documentClick(e: any) {
        const classes = ['time-selector', 'time-selector__text', 'time-selector__lists', 'time-selector__list', 'time-selector__item'];
        let needToClose = true;
        classes.forEach(className => {
            if (e.target.classList.contains(className)) {
                needToClose = false;
                return true;
            }
        });
        if (needToClose) {
            this.showSelector = false;
            this.$emit('hid')
            document.body.removeEventListener('click', this.documentClick);
        }
    }

    showTimeSelectors() {
        if (!this.showSelector) {
            this.showSelector = true;
            document.body.addEventListener('click', this.documentClick);
        }
    }

    select(variable: string, value: string) {
        this.wasSelected = true;
        if (variable == 'from') {
            this.currentFrom = value;
        }
        else {
            this.currentTo = value;
        }
        this.generateStr();
        this.emitChange();
    }
}
